// Hand-written client for the notifications API. Replace with NSwag-generated
// methods once the EpdClient is regenerated (see services/epd.nswag).

const API_URL = process.env.REACT_APP_API_URL ?? '';

export type NotificationCategory = 'ReleaseNotes' | 'News' | 'Warning' | 'System';

export interface NotificationModel {
  id: string;
  title: string;
  body: string;
  category: NotificationCategory | string;
  publishedAt: string;
  isRead: boolean;
}

export interface NotificationListModel {
  items: NotificationModel[];
  total: number;
  page: number;
  pageSize: number;
}

export interface NotificationUnreadCountModel {
  total: number;
  byCategory: Record<string, number>;
}

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const response = await fetch(`${API_URL}/api/v1/notifications${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    ...init,
  });
  if (!response.ok) {
    throw new Error(`Notifications request failed: ${response.status}`);
  }
  if (response.status === 204) {
    return undefined as unknown as T;
  }
  return (await response.json()) as T;
}

class NotificationsService {
  static list(category: string | undefined, page: number, pageSize: number): Promise<NotificationListModel> {
    const params = new URLSearchParams();
    if (category) params.set('category', category);
    params.set('page', String(page));
    params.set('pageSize', String(pageSize));
    return request<NotificationListModel>(`?${params.toString()}`);
  }

  static unreadCount(): Promise<NotificationUnreadCountModel> {
    return request<NotificationUnreadCountModel>('/unread-count');
  }

  static markAsRead(id: string): Promise<void> {
    return request<void>(`/${id}/read`, { method: 'POST' });
  }

  static markAllAsRead(category?: string): Promise<void> {
    const params = new URLSearchParams();
    if (category) params.set('category', category);
    const query = params.toString();
    return request<void>(`/read-all${query ? `?${query}` : ''}`, { method: 'POST' });
  }
}

export default NotificationsService;
